<template>
    <a-card size="small" title="短链接管理
    ">
        <a-button type="primary" slot="extra" @click="handleShow()">新建</a-button>
        <searchE @handleSearch="getAppSumData"></searchE>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">
  
            <template slot="operation" slot-scope="text, record">
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <a-pagination v-model="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize"
            @change="handlePageChange" show-less-items style="float: right; margin-top: 20px" />

        <a-modal :title="modalTitle" :visible="isShow" :confirm-loading="confirmLoading" width="450px"
            @cancel="handleCancel">
            <a-form-model layout="inline" :model="configItem" ref="ruleForm" :rules="rules" >
                <a-form-model-item label="链接url" ref="url"  prop="url">
                    <a-input style="width:400px;" v-model="configItem.url" max-Length="3000" placeholder="链接url" allow-clear></a-input>
                </a-form-model-item>
                <a-form-model-item label="唯一标识" ref="linkid"  prop="linkid">
                    <a-input style="width:400px;" v-model="configItem.linkid" max-Length="48" placeholder="唯一标识，若不传则后台生成（长度限制48字符以内）" allow-clear></a-input>
                </a-form-model-item>
            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSave">
                确定
                </a-button>
            </template>
                
        </a-modal>



    </a-card>
</template>
<script>
import searchE from './search'
let pagination={
    total:0,
    pageSize:0,
    page:1,
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "唯一标识",
        width: 200,
        dataIndex: "linkid",
        align: "center",
        ellipsises: true,
    },
    {
        title: "链接url",
        width: 400,
        dataIndex: "url",
        align: "center",
        ellipsises: true,
    },

    {
        title: "创建时间",
        width: 120,
        dataIndex: "createtime",
        ellipsis: true,
        align: "center",
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 80,
        scopedSlots: { customRender: 'operation' },
    }

    

];

export default {
    data () {
        return {
            modalTitle:'',
            isShow:false,
            confirmLoading:false,
            rules: {
                url: [
                    { required: true, message: ' 请输入链接url ', trigger: 'blur' },
                ]
            },
            configItem:{
                url:'',
                linkid:'',
            },
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            searchP:{},
            pagination,
            modalVisible:false,
        }
    },
    methods: {

        handlePageChange(v) {
            this.pagination.page = v;
            this.getAppSumData();
        },
        getAppSumData(sp){
            let that = this
            that.searchP = sp;
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'open/shortLinkPage',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSave(){
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    //新增
                    that.$store
                        .dispatch({
                            type: "open/shortLinkAdd",
                            params: that.configItem
                        })
                        .then((response) => {
                            if(response.data.success == '1'){
                                that.handleCancel();

                            }
                            that.confirmLoading = false;

                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleShow(){
            this.isShow = true;
            this.modalTitle = '生成短链接'
            this.configItem = {
                url:'',
                linkid:'',
            }
        },
        handleDelete(record){
            let that = this;
            that.$store.dispatch({
                type: "open/shortLinkDel",
                params: {linkid: record.linkid}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
        },
        handleCancel(){
            this.configItem = {
                url:'',
                linkid:'',
            }
            this.isShow = false;
            this.pagination.page = 1;

            this.getAppSumData()
        },
    },
    components:{
        searchE,
    },
};
</script>

<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>
